import { includes, isEmpty, pickBy } from 'lodash';
export const filterEmptyValues = object => pickBy(object, val => !(Array.isArray(val) && isEmpty(val) || val === null || typeof val === 'undefined'));
export const nullifyEmptyValue = value => isEmpty(value) ? null : value;
export const isValueInObject = (value, object) => includes(Object.values(object), value);
export const isObjectKey = (key, object) => {
  return key in object;
};
export const filterEmptyStringAttributes = object => pickBy(object, val => String(val));
export const isObject = candidate => !!candidate && typeof candidate === 'object';
export const deleteUndefinedValues = object => {
  if (!object) return; // eslint-disable-next-line no-restricted-syntax

  for (const key in object) {
    if (!Object.hasOwn(object, key)) continue; // eslint-disable-line no-continue

    const value = object[key];
    if (isObject(value)) deleteUndefinedValues(value);else if (value === undefined) delete object[key]; // eslint-disable-line no-param-reassign
  }
};